module.exports = __webpack_public_path__ + "8472a78d1a0f58e45d3951a6f48479ff.svg";